const FEATURE_HELP_URLS = {
  agent_bots: 'https://www.kraftchat.com.br/ajuda/agent-bots',
  agents: 'https://www.kraftchat.com.br/ajuda/agents',
  audit_logs: 'https://www.kraftchat.com.br/ajuda/audit-logs',
  campaigns: 'https://www.kraftchat.com.br/ajuda/campaigns',
  canned_responses: 'https://www.kraftchat.com.br/ajuda/canned',
  channel_email: 'https://www.kraftchat.com.br/ajuda/email',
  channel_facebook: 'https://www.kraftchat.com.br/ajuda/fb',
  custom_attributes: 'https://www.kraftchat.com.br/ajuda/custom-attributes',
  dashboard_apps: 'https://www.kraftchat.com.br/ajuda/dashboard-apps',
  help_center: 'https://www.kraftchat.com.br/ajuda/help-center',
  inboxes: 'https://www.kraftchat.com.br/ajuda/inboxes',
  integrations: 'https://www.kraftchat.com.br/ajuda/integrations',
  labels: 'https://www.kraftchat.com.br/ajuda/labels',
  macros: 'https://www.kraftchat.com.br/ajuda/macros',
  reports: 'https://www.kraftchat.com.br/ajuda/reports',
  sla: 'https://www.kraftchat.com.br/ajuda/sla',
  team_management: 'https://www.kraftchat.com.br/ajuda/teams',
  webhook: 'https://www.kraftchat.com.br/ajuda/webhooks',
  billing: 'https://www.kraftchat.com.br',
  saml: 'https://www.kraftchat.com.br/ajuda/saml',
  captain_billing: 'https://www.kraftchat.com.br/ajuda/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
